module.exports = __webpack_public_path__ + "img/timer.a03ed834.png";